<!-- O modal não tem slot de conteúdo livre: o conteúdo vai no slot "description". -->
<vivest-modal
  [heading]="titulo()"
  [hasIcon]="false"
  open
  dismissible
  (vivest-close)="fechar.emit()"
  data-testid="impedimento-modal"
>
  <div slot="description" class="impedimento-modal">
    <fieldset class="impedimento-modal__grupo" aria-describedby="impedimento-modal-dica">
      <legend class="impedimento-modal__rotulo">
        Não pode ser elegível a<span class="impedimento-modal__obrigatorio" aria-hidden="true">*</span>
      </legend>
      <p id="impedimento-modal-dica" class="impedimento-modal__dica">
        O participante não poderá solicitar {{ beneficio() }} se atender a todas as condições marcadas.
      </p>
      <ul class="impedimento-modal__condicoes">
        @for (opcao of opcoes(); track opcao.id) {
          <li>
            <vivest-checkbox
              label-variant="multi-line"
              name="impedimento-condicoes"
              [value]="opcao.id"
              [checked]="beneficiosMarcados().has(opcao.id)"
              (change)="alternarBeneficio(opcao.id, $any($event.target).checked)"
              [attr.data-testid]="'impedimento-modal-beneficio-' + opcao.id"
            >
              Elegível a {{ opcao.nome }}
            </vivest-checkbox>
          </li>
        }

        @for (condicao of condicoesIdade; track condicao.id) {
          <li>
            <vivest-checkbox
              label-variant="multi-line"
              name="impedimento-condicoes"
              [value]="condicao.id"
              [checked]="idadeMarcada(condicao.id)"
              (change)="alternarIdade(condicao, $any($event.target).checked)"
              [attr.data-testid]="'impedimento-modal-' + condicao.id"
            >
              {{ condicao.rotulo }}
            </vivest-checkbox>

            @if (idadeMarcada(condicao.id)) {
              <div class="impedimento-modal__parametro">
                <label class="impedimento-modal__parametro-frase" [for]="'impedimento-modal-valor-' + condicao.id">
                  <span>{{ condicao.prefixo }}</span>
                  <input
                    #campoIdade
                    [id]="'impedimento-modal-valor-' + condicao.id"
                    class="form-control impedimento-modal__valor"
                    type="text"
                    inputmode="numeric"
                    autocomplete="off"
                    maxlength="3"
                    required
                    [attr.aria-label]="condicao.rotulo + ' em anos'"
                    [attr.aria-invalid]="tentouSalvar() && errosIdade().has(condicao.id)"
                    [attr.aria-describedby]="tentouSalvar() && errosIdade().has(condicao.id) ? 'impedimento-modal-erro-' + condicao.id : null"
                    [class.is-invalid]="tentouSalvar() && errosIdade().has(condicao.id)"
                    [value]="valorIdade(condicao.id)"
                    (input)="digitarIdade(condicao.id, campoIdade)"
                    [attr.data-testid]="'impedimento-modal-valor-' + condicao.id"
                  />
                  <span>anos de idade</span>
                </label>
                @if (tentouSalvar() && errosIdade().get(condicao.id); as erro) {
                  <p [id]="'impedimento-modal-erro-' + condicao.id" class="impedimento-modal__erro" role="alert">{{ erro }}</p>
                }
              </div>
            }
          </li>
        }
      </ul>
      @if (tentouSalvar() && semCondicao()) {
        <p class="impedimento-modal__erro" role="alert" data-testid="impedimento-modal-erro">
          Marque ao menos uma condição.
        </p>
      }
    </fieldset>

    <div class="impedimento-modal__grupo">
      <label class="impedimento-modal__rotulo" for="impedimento-modal-mensagem">Mensagem de não elegibilidade (opcional)</label>
      <textarea
        id="impedimento-modal-mensagem"
        class="form-control impedimento-modal__textarea"
        rows="3"
        placeholder="Ex.: A Aposentadoria Antecipada não está disponível porque você já é elegível à Aposentadoria Normal."
        [attr.maxlength]="mensagemMaximo"
        [value]="mensagem()"
        (input)="mensagem.set($any($event.target).value)"
        aria-describedby="impedimento-modal-mensagem-dica"
        data-testid="impedimento-modal-mensagem"
      ></textarea>
      <p id="impedimento-modal-mensagem-dica" class="impedimento-modal__dica impedimento-modal__contador">
        <span>Exibida ao participante que cair nesta regra.</span>
        <span>{{ mensagem().length }}/{{ mensagemMaximo }}</span>
      </p>
    </div>
  </div>

  <vivest-button slot="actions" variant="outline" size="md" data-testid="impedimento-modal-cancelar" (click)="fechar.emit()">
    Cancelar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="impedimento-modal-salvar" (click)="confirmar()">
    {{ regra() ? 'Salvar regra' : 'Adicionar regra' }}
  </vivest-button>
</vivest-modal>
